import React from 'react';
import styles from './RadioBlock.module.scss';
import Radio from '../../../../components/style-guide/form/radio/Radio';
import clsx from 'clsx';

export const RadioBlock = props => {
  const {
    className,
    start,
    end,
    ...other
  } = props;

  return (
    <div className={clsx(styles.radioBlock, className)}>
      <span className={styles.content}>
        <Radio {...other} />
      </span>
      <span className={clsx(styles.right)}>
        {end}
      </span>
    </div>
  );
};

RadioBlock.propTypes = {};

export default RadioBlock;
